(() => {

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const enhance = (root = document) => {

    if (document.body.classList.contains('motion-enabled') && !reduced.matches && 'IntersectionObserver' in window) {

      const observer = new IntersectionObserver(entries => entries.forEach(entry => {

        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }

      }), { threshold: 0.08 });

      root.querySelectorAll('[data-reveal]').forEach(el => {

        if (el.getBoundingClientRect().top > innerHeight) { el.classList.add('reveal-ready'); observer.observe(el); }

      });

    }
    root.querySelectorAll('.product-image').forEach(card => {
      const back = card.querySelector('.product-secondary');
      if (!back || card.dataset.xrayBound) return;
      card.dataset.xrayBound = 'true';
      let frame;
      const move = event => {
        if (event.pointerType === 'touch' || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (!back.complete || !back.naturalWidth) return;
          const rect = card.getBoundingClientRect();
          card.style.setProperty('--xray-x', `${event.clientX - rect.left}px`);
          card.style.setProperty('--xray-y', `${event.clientY - rect.top}px`);
          card.classList.add('xray-active');
        });
      };
      card.addEventListener('pointerenter', move, { passive: true });
      card.addEventListener('pointermove', move, { passive: true });
      card.addEventListener('pointerleave', () => {
        cancelAnimationFrame(frame);
        card.classList.remove('xray-active');
      });
    });

    root.querySelectorAll('[data-variant-select]').forEach(select => {

      if (select.dataset.bound) return;

      select.dataset.bound = 'true';

      select.addEventListener('change', () => {

        const option = select.selectedOptions[0];

        const price = select.closest('.product-details').querySelector('[data-product-price]');

        if (price) price.textContent = option.dataset.price;

        const button = select.form.querySelector('[name=add]');

        button.disabled = option.dataset.available !== 'true';

        button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;

        const quantity = select.form.querySelector('[name=quantity]');

        quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';

        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');

        quantity.value = quantity.min;

        const compare = select.closest('.product-details').querySelector('s');

        if (compare) compare.hidden = true;

        const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);

      });

    });

  };

  reduced.addEventListener('change', () => { if (reduced.matches) document.querySelectorAll('.reveal-ready').forEach(el => el.classList.add('is-visible')); });

  enhance();

  document.addEventListener('shopify:section:load', event => enhance(event.target));

  document.addEventListener('keydown', event => {

    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => { menu.removeAttribute('open'); menu.querySelector('summary').focus(); });

  });

})();

